    /**
 * TDP Scroll Reveal — Lightweight IntersectionObserver
 * Replicates: ScrollReveal.tsx (Framer Motion whileInView)
 * Upload to: Shopify Admin → assets/tdp-scroll-reveal.js
 */
(function() {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var delay = el.getAttribute('data-tdp-delay') || '0';
        el.style.transitionDelay = delay + 'ms';
        el.classList.add('tdp-revealed');
        observer.unobserve(el);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -40px 0px'
  });

  function init() {
    var elements = document.querySelectorAll('.tdp-reveal');
    elements.forEach(function(el) {
      observer.observe(el);
    });
  }

  // Run on DOMContentLoaded and also when Shopify sections are loaded/reordered
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when sections are added/reloaded in Theme Editor
  document.addEventListener('shopify:section:load', init);
})();

    
